import { useContext } from "react";
import { ReportFolioDetailContext } from "../context";

export const useReportFoliosDetailContext = () => useContext(ReportFolioDetailContext)